import axios from "axios";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import apiClient from "../../../lib/api_client";

// --------------------------------------------- RelevantSetsDesigns ------------------------------------------------

const fetchRelevantSets = async ({ pageParam = 1, queryKey }) => {
  const [, styleNumber, limit] = queryKey;
  const res = await apiClient.post("/getRelevantSetsDesigns", {
    styleNumber,
    page: pageParam,
    limit,
  });
  return res.data;
};

export function useRelevantSets(styleNumber, limit = 100) {
  return useInfiniteQuery({
    queryKey: ["relevantSets", styleNumber, limit],
    queryFn: fetchRelevantSets,
    getNextPageParam: (lastPage) => {
      const { pagination } = lastPage;
      return pagination?.currentPage < pagination?.totalPages
        ? pagination.currentPage + 1
        : undefined;
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!styleNumber,
  });
}

// --------------------------------------------- RecommendedDesigns ------------------------------------------------

const fetchRecommendedDesigns = async ({ pageParam = 1, queryKey }) => {
  const [, clientCode,styleNumber, avgDiaWeight, avgNetWeight, limit] = queryKey;
  const res = await apiClient.post("/getRecommendedDesigns", {
    clientCode,
    styleNumber,
    avgDiaWeight,
    avgNetWeight,
    pageNo: pageParam,
    limit,
  });
  return res.data.data;
};

export function useRecommendedDesigns({
  clientCode,
  styleNumber,
  avgDiaWeight = "",
  avgNetWeight = "",
  limit = 10,
}) {
  return useInfiniteQuery({
    queryKey: [
      "recommendedDesigns",
      clientCode,
      styleNumber,
      avgDiaWeight,
      avgNetWeight,
      limit,
    ],
    queryFn: fetchRecommendedDesigns,
    getNextPageParam: (lastPage) => {
      const { pagination } = lastPage;
      return pagination?.currentPage < pagination?.totalPages
        ? pagination.currentPage + 1
        : undefined;
    },
    retry: false,
    // enabled: !!clientCode && !!avgDiaWeight && !!avgNetWeight,
    enabled: !!clientCode,
  });
}

// --------------------------------------------- getPreviousPurchaseAndAvgCatgeoryData ------------------------------------------------

const fetchPurchaseAndCategoryData = async (clientCode, styleNumber) => {
  const { data } = await apiClient.get(
    `/getPreviousPurchaseAndAvgCatgeoryData?clientCode=${clientCode}&styleNumber=${styleNumber}`
  );
  return data;
};

const usePurchaseAndCategoryData = (clientCode, styleNumber) => {
  return useQuery({
    queryKey: ["purchaseCategoryData", clientCode, styleNumber],
    queryFn: () => fetchPurchaseAndCategoryData(clientCode, styleNumber),
    enabled: !!clientCode,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: false,
  });
};

export default usePurchaseAndCategoryData;

//----------------------------------------------video Screen API----------------------

export const fetchUspandVideo = async (styleNumber) => {
  const { data } = await apiClient.get(`usp/${styleNumber}`);
  return {
    imageData: data?.USPDetails?.images,
    videoData: data?.USPDetails?.videos,
    uspMessage: data?.USPDetails?.uspMsg,
    styleNumber: data?.USPDetails?.styleNumber,
  };
};

export const useUspAndVideoData = (styleNumber) => {
  return useQuery({
    queryKey: ["UspAndVideoData", styleNumber],
    queryFn: () => fetchUspandVideo(styleNumber),
    staleTime: 5 * 60 * 1000,
  });
};
